import { useState, useEffect } from "react";
// material
import { Box, Card, Typography, TableCell, TableBody, TableContainer, Table, TableRow } from "@mui/material";
import moment from "moment";
import _ from 'lodash';
// components
import Scrollbar from "../table/Scrollbar";
import {
  formatDateFilter,
  applySortFilter,
  parseDateTime,
} from "../../utils/tableFunctions";

import { sendDataWithPost } from "../../services/services";
import ListHead from "../table/ListHead";
import { StyledTableRow } from "../TableRow";
import CircularLoader from "../circularLoader";
import FormSearch from "../FormSearch";

// ----------------------------------------------------------------------

const defaultValue = {
  start_datetime: moment(),
  end_datetime: moment(),
  service_scope: "AdminPortal"
}

const TABLE_HEAD = [
  { id: "log_datetime", label: "Date" },
  // { id: "service_scope", label: "Service" },
  { id: "message", label: "Message", align: "left" },
];

export default function AuditLogsList() {
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState({
    results: []
  });

  // ------------------ filterStuffies --------------------//
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [filter, setFilter] = useState(defaultValue);

  // const filter = {
  //   username: fUserName,
  //   start_datetime: formatDateFilter(fDate[0], "start"),
  //   end_datetime: formatDateFilter(fDate[1], "end"),
  //   page_size: 10,
  //   message: fMessage?.toLowerCase(),
  //   next_token: "",
  //   service_scope: fServiceScope
  // };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = applySortFilter(
    tableData?.results || [],
    order,
    orderBy
  );

  const queryPage = (newFParams) => {
    const url = "/auditlog/query/";
    loaded && setLoaded(false);
    sendDataWithPost(url, newFParams || filter, setTableData, setLoaded)
  };

  const onFilterSubmit = (fParams) => {
    const { start_datetime, end_datetime } = fParams;
    const newFParams = {
      ...fParams,
      start_datetime:
        start_datetime && moment(start_datetime).isValid()
          ? formatDateFilter(start_datetime, "start")
          : null,
      end_datetime:
        end_datetime && moment(end_datetime).isValid()
          ? formatDateFilter(end_datetime, "end")
          : null,
      message: fParams?.message?.trim(),
    };

    setFilter(newFParams);
    queryPage(newFParams);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    const { start_datetime, end_datetime } = filter;
    const newFParams = {
      ...defaultValue,
      start_datetime:
        start_datetime && moment(start_datetime).isValid()
          ? formatDateFilter(start_datetime, "start")
          : null,
      end_datetime:
        end_datetime && moment(end_datetime).isValid()
          ? formatDateFilter(end_datetime, "end")
          : null,
    };
    queryPage(newFParams);
  }, []);

  const isUserNotFound = tableData?.results?.length === 0;

  function highLightString(originalString) {
    const match = originalString.match(/^\[(info|error)\]/);

    if (!match && !match?.[0]) return originalString

    const stringWithoutValue = originalString.replace(match[0], '');
    const color = match[0] === '[info]' ? '#cccccc' : '#8b0000'

    const stringWithReplacedValue = (
      <>
        <Box component="span" color={color}>{_.capitalize(match[0])}</Box>
        {stringWithoutValue}
      </>
    );

    return stringWithReplacedValue
  }

  const schema = [
    {
      type: "daterange",
      label: "Date",
      param: ["start_datetime", "end_datetime"],
      width: 6
    },
    // {
    //   type: "select",
    //   label: "Service scope",
    //   param: "service_scope",
    //   options: [
    //     { name: "AdminPortal", id: "AdminPortal" },
    //   ]
    // },
    {
      type: "text",
      label: "Message",
      param: "message",
    },
  ]

  return (
    <Box>
      <FormSearch
        schema={schema}
        loading={false}
        onSearch={onFilterSubmit}
        defaultValue={defaultValue}
      />
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableContainer sx={{ maxHeight: "calc(100vh - 300px)" }}>
              <Table stickyHeader>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  headLabel={TABLE_HEAD}
                  checkbox={false}
                />
                <TableBody>
                  {filteredList?.map((row, i) => {
                    const { service_scope, username, message, log_datetime } = row

                    return (
                      <StyledTableRow hover key={i} sx={{ cursor: "default"}}>
                        <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>{log_datetime ? parseDateTime(log_datetime) : ""}</TableCell>
                        {/* <TableCell align="left">{service_scope}</TableCell> */}
                        <TableCell align="left">{highLightString(message)}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                        <Typography gutterBottom align="center" variant="subtitle1">
                          Not found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}
    </Box>
  );
}
